import {
    List,
    ListItem,
    ListItemAvatar,
    ListItemButton,
    ListItemText,
    Stack,
    Typography,
} from '@mui/material';
import {
    RecordContextProvider,
    SimpleListLoading,
    useListContext,
} from 'react-admin';
import { AnimationCover } from './AnimationCover';
import { MissionTypeChipFromId } from '@app/mission/chips/MissionTypeChip';
import { AnimationLight } from '@wwf/sdk';

export const AnimationListContent = ({
    openDrawer,
}: {
    openDrawer?: (id: AnimationLight['id']) => void;
}) => {
    const { data, error, isPending } = useListContext<AnimationLight>();

    if (isPending) {
        return <SimpleListLoading hasLeftAvatarOrIcon hasSecondaryText />;
    }
    if (error) return null;
    if (!data?.length) {
        return (
            <Stack p={2}>
                <Typography>No animations found</Typography>
            </Stack>
        );
    }

    return (
        <List dense>
            {data.map(animation => (
                <RecordContextProvider key={animation.id} value={animation}>
                    <ListItem
                        disablePadding
                        sx={{
                            backgroundColor:
                                animation.enabled === false
                                    ? 'grey.100'
                                    : 'white',
                        }}
                    >
                        <ListItemButton
                            onClick={() =>
                                animation.id != null &&
                                openDrawer?.(animation.id)
                            }
                            alignItems="center"
                        >
                            <ListItemAvatar>
                                <AnimationCover />
                            </ListItemAvatar>
                            <ListItemText
                                primary={
                                    <Stack
                                        direction="row"
                                        gap={1}
                                        alignItems="center"
                                    >
                                        {animation.missionType && (
                                            <MissionTypeChipFromId
                                                id={animation.missionType}
                                            />
                                        )}
                                        {animation.name}
                                    </Stack>
                                }
                                secondary={[
                                    animation.theme,
                                    animation.duration,
                                    animation.ageTarget,
                                    animation.description,
                                ]
                                    .filter(Boolean)
                                    .join(' • ')}
                            />
                        </ListItemButton>
                    </ListItem>
                </RecordContextProvider>
            ))}
        </List>
    );
};
